import { render, staticRenderFns } from "./HazardEdit.vue?vue&type=template&id=b3b3d7aa"
import script from "./HazardEdit.vue?vue&type=script&lang=js"
export * from "./HazardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports